import { FC, useState } from "react";
import { getWheelRaffleErrorMessage } from "entities/wheel-raffle";
import { FormInput, formStyles } from "shared/ui";
import { useJoinWheelRaffleMutation } from "../api/joinWheelRaffleApi";

import styles from "./JoinRaffleForm.module.css";

interface Props {
  raffleId: number;
  // Код, по которому розыгрыш нашли в поиске, — подставляем сразу.
  initialCode?: string | null;
}

// После успеха деталь перезапросится с has_joined=true и форма скроется.
export const JoinRaffleForm: FC<Props> = ({ raffleId, initialCode }) => {
  const [code, setCode] = useState(initialCode ?? "");
  const [join, { isLoading, error, reset }] = useJoinWheelRaffleMutation();

  return (
    <form
      className={styles.join}
      onSubmit={(event) => {
        event.preventDefault();
        join({ raffleId, inviteCode: code });
      }}
    >
      <div className={styles.input}>
        <FormInput
          placeholder="Invite code"
          aria-label="Invite code"
          maxLength={64}
          value={code}
          error={getWheelRaffleErrorMessage(error)}
          onValueChange={(value) => {
            setCode(value);
            reset();
          }}
          disabled={isLoading}
        />
      </div>
      <button
        type="submit"
        className={`${formStyles.outlineButton} ${formStyles.accent} ${styles.button}`}
        disabled={!code.trim() || isLoading}
      >
        {isLoading ? "Joining..." : "Join"}
      </button>
    </form>
  );
};
